import ModelSelectionButtonSVG from "../../Media/ModelSelectionButton";
import styled from "styled-components";
import useStore from "../../Store/Store";
import PsychologyIcon from "@mui/icons-material/Psychology";
import Tooltip from "@mui/material/Tooltip";

const ModelSelectionButtonWrapper = styled.div`
  position: fixed;
  top: 30vh; /* Moved up from 35vh, maintaining 10vh spacing */
  left: -0.7vw;
  height: 5vw;
  width: 5vw;
  cursor: pointer;

  /* Hover states */
  &:hover .brainIcon {
    fill: #ffaea6;
    color: #ffaea6;
  }
  &:hover .halfCircle {
    fill: white;
  }
  &:hover .pencil {
    fill: #ffb6a6;
  }
`;

const ModelSelectionButton: React.FC = () => {
  const { setShowOnboardingModelSelectionDialog } = useStore((state) => ({
    setShowOnboardingModelSelectionDialog:
      state.setShowOnboardingModelSelectionDialog,
  }));

  const handleClick = () => {
    setShowOnboardingModelSelectionDialog(true);
  };

  return (
    <Tooltip title="Regenerate With Pro Model">
      <ModelSelectionButtonWrapper
        className="ModelSelectionButtonWrapper"
        onClick={handleClick}
      >
        <ModelSelectionButtonSVG />
        <PsychologyIcon
          htmlColor="#ffffff"
          style={{
            position: "absolute",
            top: "30%",
            left: "18%",
            width: "30px",
            height: "30px",
          }}
          className="brainIcon"
        />
      </ModelSelectionButtonWrapper>
    </Tooltip>
  );
};

export default ModelSelectionButton;
